





























































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Modal } from '@/components/general'
import { BondControlTableList, BondControlFormCreateEdit, FiltersBondControl as Filters } from '@/components/dailyControl'

// services
import { BondControlService } from '@/services/dailyControl'

// models
import { Paginator } from '@/models'
import { BondControl, BondControlForm, FiltersBondControl } from '@/models/dailyControl'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const bondControlDefault: BondControlForm = {
  employee_id: 0,
  headquarter_id: 0,
  area_id: 0,
  sub_area_id: 0,
  year: 0,
  month: 0,
  fortnight: 0,
  loaded_massive: false,
  bond_type_id: 0,
  amount: 0,
  abstents_first_week: 0,
  abstents_second_week: 0,
  observations: ''
}

export default defineComponent({
  name: 'BondControlIndex',
  components: {
    PageHeader,
    BondControlTableList,
    Modal,
    BondControlFormCreateEdit,
    ButtonExport,
    Filters,
    AccordionFilters
  },
  setup () {
    const showModal = ref(false)
    const title = 'Control de Bonos'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Control de Bono'
      }
      return 'Crear Control de Bono'
    })
    const items = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Bonos',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const filters: Ref<FiltersBondControl> = ref({
      headquarter: 0,
      area: 0,
      sub_area: 0,
      fortnight: 0,
      year: 0,
      month: 0,
      loaded_massive: false,
      bond_types: []
    })
    const bondControl: Ref<BondControlForm> = ref(bondControlDefault)
    const bondControls: Ref<BondControl[]> = ref([])
    const getBondControlWithPagination = async () => {
      loading('show')
      const res = await BondControlService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = res.pagination
      bondControls.value = res.objects
      loading('hide')
    }
    getBondControlWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      bondControl.value = {
        ...bondControlDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      bondControl.value = {
        ...bondControlDefault
      }
      idEdit.value = null
      getBondControlWithPagination()
    }
    const editItem = (item: BondControl) => {
      bondControl.value = {
        employee_id: item.employee_id,
        headquarter_id: item.headquarter_id,
        area_id: item.area_id,
        sub_area_id: item.sub_area_id,
        year: item.year,
        month: item.month,
        fortnight: item.fortnight,
        loaded_massive: item.loaded_massive,
        bond_type_id: item.bond_type_id,
        amount: item.amount,
        abstents_first_week: item.abstents_first_week,
        abstents_second_week: item.abstents_second_week,
        observations: item.observations ?? ''
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: BondControl) => {
      const msg = `Seguro que desea eliminar el Bono del empleado: ${item.employee.fullName}.`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await BondControlService.delete(item.id)
        alerts.success()
        getBondControlWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getBondControlWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getBondControlWithPagination()
    }

    const headersExcel = [
      { text: 'Empleado', value: 'employee' },
      { text: 'Importe Bono', value: 'amount' }
    ]

    const allBondControl: Ref<BondControl[]> = ref([])

    const itemsExcel = computed(() => {
      return allBondControl.value.map(item => {
        return {
          ...item,
          employee: getFullNameFormat(item.employee)
        }
      })
    })

    const getAllitems = async () => {
      allBondControl.value = await BondControlService.getAll(filters.value)
    }

    const getByFilters = () => {
      pagination.value.currentPage = 1
      getBondControlWithPagination()
    }

    const clearFilters = () => {
      pagination.value.currentPage = 1
      filters.value = {
        headquarter: 0,
        area: 0,
        sub_area: 0,
        fortnight: 0,
        year: 0,
        month: 0,
        loaded_massive: false,
        bond_types: []
      }
      getBondControlWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      saveSuccess,
      allBondControl,
      bondControl,
      bondControls,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems,
      getByFilters,
      clearFilters,
      filters
    }
  }
})
